const ITEMS = ["Taj Mahal", "Kashmir", "Rajasthan", "Kerala Backwaters", "Ladakh", "Varanasi", "Goa", "Golden Triangle", "Himalayas", "Wildlife Safaris", "Yoga & Wellness", "Royal Palaces"];

export default function Marquee() {
  const loop = [...ITEMS, ...ITEMS];
  return (
    <section data-testid="marquee" className="relative bg-[#7c1d1d] text-[#fdfbf7] py-5 overflow-hidden border-y border-[#d4af37]/40">
      <div className="absolute inset-0 opacity-15 paper-grain pointer-events-none" />
      <div className="relative flex whitespace-nowrap marquee-track">
        {loop.map((label, i) => (
          <div key={`${label}-${i}`} className="flex items-center gap-6 px-8 text-lg sm:text-2xl font-serif italic tracking-wide">
            <span>{label}</span>
            <span className="inline-block w-2 h-2 rotate-45 bg-[#d4af37]" />
          </div>
        ))}
      </div>
    </section>
  );
}
